import { useParams } from "react-router-dom"
import Form from "./form";
import usePrivateCompanyLead from "@/features/privateCompanyLeadsFunnel/hooks/usePrivateCompanyLead";

const Update = () => {
  const { id, privateCompanyLeadId } = useParams();
  const { data: privateCompanyLead, isPending: isLoadingPrivateCompanyLead } = usePrivateCompanyLead(privateCompanyLeadId || '');

  return (
    <>
      {(!isLoadingPrivateCompanyLead && !!privateCompanyLead) && (
        <Form 
          contact={privateCompanyLead.contacts?.find((contact) => contact.id === id)}
          privateCompanyLeadState={privateCompanyLead.state}
          privateCompanyRestContacts={privateCompanyLead?.contacts?.filter((contact) => contact.id !== id) || []}
          privateCompanyLeadName={privateCompanyLead?.display_name}
        />
      )}
    </>
  )
}

export default Update